module.exports = __webpack_public_path__ + "img/zalesha.1b0eb5bf.jpg";